export default function initProductDetails() {
  const $productChoice = $('[data-product-details-choice]');
  $productChoice.on('click', (e) => {
    const $target = $(e.target);
    const choice = $target.data('product-details-choice');
    const $chosenDetail =  $('[data-product-details-content="' + choice + '"]');
    if ($chosenDetail.hasClass('d-none')) {
      $productChoice.removeClass('bg-dark-blue');
      $target.addClass('bg-dark-blue');
      $('[data-product-details-content]')
        .addClass('d-none')
        .attr('aria-hidden', 'true');
      $chosenDetail
        .removeClass('d-none')
        .attr('aria-hidden', 'false');
    }
  });
  const $productReadMoreButton = $('[product-read-more-button]');
  const $productReadMoreContainer = $('[product-read-more-container]');
  const readLessTranslation = $productReadMoreButton.attr('read-less-text');
  const readMoreTranslation = $productReadMoreButton.attr('read-more-text');

  if ($productReadMoreContainer.length > 0) {
    if ($productReadMoreContainer[0].offsetHeight >= 450) {
      $productReadMoreButton.removeClass('d-none');
    }
    $productReadMoreButton.on('click', (e) => {
      if ($productReadMoreContainer.hasClass('max-height-450')) {
        $productReadMoreContainer.removeClass('max-height-450');
        $productReadMoreButton[0].innerText = readLessTranslation;
      } else {
        $productReadMoreContainer.addClass('max-height-450');
        $productReadMoreButton[0].innerText = readMoreTranslation;
      }
    });
  }

  const $table = $('.specifications table');
  if ($table) {
    $table.addClass('table-striped table-responsive');
  }

  const $mainImage = $('[main-image]')
    .find('img');
  const $mainImageLightbox = $('[main-image]')
      .find('a');
  const $previewImage = $('[preview-image]');
  $previewImage.on('click', (e) => {
    $previewImage.css('opacity', '0.5');
    $(e.target).first().parent().css('opacity', '1');
    $mainImage[0].src = e.target.dataset.imgSrc;
    $mainImageLightbox[0].href = e.target.dataset.src;
  });
}
